/* eslint @typescript-eslint/naming-convention: 0 */
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface SearchExperienceByPreferenceParams {
  search_preference: string;
}

const buildSearchExperienceByPreferenceParams = (preferences: string[]): SearchExperienceByPreferenceParams => {
  const joinedPreferences = preferences.sort().join(',');
  return { search_preference: joinedPreferences };
};

/**
 * 発火タイミング：検索発火時
 * @param preferences カンマ区切りのプリファレンスの文字列
 * @returns
 */
export const sendGAWabunkaSearchExperienceByPreferenceEvent = (preferences: string) => {
  if (preferences === '') {
    return;
  }
  sendWabunkaGAEvent('search_experience_by_preference', buildSearchExperienceByPreferenceParams(preferences.split(',')));
};
